import { Eyebrow, Reveal } from "./Reveal";

const QUOTES = [
    {
        quote:
            "Pemasangan partisi kaca kantornya rapi sekali — sambungannya hampir tak terlihat. Jadwal juga tidak meleset.",
        who: "Ibu Atik",
        ctx: "Proyek Partisi Kaca",
    },
    {
        quote:
            "Dari survei sampai pasang folding door di teras, semuanya jelas. Rumah jadi terasa jauh lebih terang.",
        who: "Bapak Abbad",
        ctx: "Proyek Kaca & Aluminium",
    },
];

export default function Testimonials() {
    return (
        <section id="testimoni" className="py-24 lg:py-32">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
                <Reveal>
                    <Eyebrow>Kata Klien</Eyebrow>
                </Reveal>
                <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-8">
                    {QUOTES.map((q, i) => (
                        <Reveal key={q.who} delay={i * 0.08}>
                            <div
                                data-testid="testimonial-card"
                                className="flex h-full flex-col justify-between border border-white/10 bg-elevated p-8 transition-[border-color] duration-500 hover:border-white/30 lg:p-12"
                            >
                                <p className="font-serif text-2xl italic leading-snug text-zinc-100 lg:text-[1.7rem]">
                                    “{q.quote}”
                                </p>
                                <div className="mt-10 flex items-center justify-between gap-4">
                                    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">
                                        {q.who}
                                    </span>
                                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                                        {q.ctx}
                                    </span>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
